import React from "react";
import Cookies from "js-cookie";
import { MsalAuthProvider, LoginType } from "react-aad-msal";
import { Logger, LogLevel } from "msal";
// Removed jose library imports as encryption is no longer used
// import {
//   generateSecret,
//   CompactEncrypt,
//   compactDecrypt,
//   importSPKI,
//   importPKCS8,
// } from "jose";

// Private variables for cookies
const COOKIE_NAME = "app_token";

// Note: Encryption removed as per security audit recommendation
// PEM keys should never be publicly accessible
// Token security now relies on:
// - HTTPS transport encryption
// - Short token expiration
// - sessionStorage (cleared on tab close)
// - CSRF protection on backend

// Get credentials from settings file
const getCredentials = async () => {
  return fetch("/appSettings.json")
    .then((res) => res.json())
    .then((result) => result)
    .catch(console.log);
};
let tokenCred = await getCredentials();
const authProvider = new MsalAuthProvider(
  {
    auth: {
      authority: tokenCred.Authority,
      clientId: tokenCred.Client_ID,
      postLogoutRedirectUri: tokenCred.ENVIRTUAL_BASE_URL,
      redirectUri: `${tokenCred.ENVIRTUAL_BASE_URL}/entrance`,
      validateAuthority: true,
      navigateToLoginRequestUrl: false,
    },
    system: {
      logger: new Logger(
        (logLevel, message, containsPii) => {
          console.log(`MSAL Log - ${logLevel}: ${message}`);
        },
        {
          level: LogLevel.Verbose,
          piiLoggingEnabled: false,
        }
      ),
    },
    cache: {
      cacheLocation: "sessionStorage", // Temporarily use sessionStorage, will be cleared
      storeAuthStateInCookie: false, // No cookies
    },
  },
  {
    scopes: ["openid"],
  },
  {
    loginType: LoginType.Redirect,
    tokenRefreshUri: `${window.location.origin}/auth.html`,
  }
);
export const fetchUserData = async () => {
  const account = authProvider.getAccount();
  debugger;
  if (account) {
    try {
      // Attempt to acquire token silently
      const tokenResponse = await authProvider.acquireTokenSilent({
        scopes: ["openid"],
        loginHint: account.userName, // Use the loginHint for silent token request
      });
      // Store the token directly in sessionStorage (no encryption)
      // Security relies on HTTPS, short token expiration, and CSRF protection
      sessionStorage.clear();
      sessionStorage.setItem(COOKIE_NAME, tokenResponse.idToken.rawIdToken);
    } catch (error) {
      // Handle errors (e.g., token acquisition failed)
      console.error("Token acquisition error:", error);

      // Optionally redirect to login page if silent token acquisition fails
      await authProvider.logout();
    }
  }
};
// Initialize auth provider
const getAll = async () => {
  return authProvider;
};

// Function to retrieve the ID token from sessionStorage
export const getIdToken = async () => {
  const token = sessionStorage.getItem(COOKIE_NAME);
  return token;
};

export default getAll().then((r) => r);
